import { LogAdapter } from 'library/ts/utilities/logger/adapters/LogAdapter';
import { ILogAdapter } from 'library/ts/utilities/logger/interfaces/adapters/ILogAdapter';

export class ConsoleLogAdapter extends LogAdapter implements ILogAdapter {
	static #instance: ConsoleLogAdapter;

	static create = (): ConsoleLogAdapter => {
		if ( !ConsoleLogAdapter.#instance )
			ConsoleLogAdapter.#instance = new ConsoleLogAdapter();

		return ConsoleLogAdapter.#instance;
	};
	#base: Console;

	constructor() {
		super();
		// store console as our "base", to circumvent any automated
		// removal or detection of 'console.log' statements
		this.#base = console;
	}

	// this adapter's API cannot directly reference unwrapped console functions
	// because PS4 has trouble parsing operations involving native functions
	log = ( ...messages ) => {
		this.#base.log( ...messages );
	};

	info = ( ...messages ) => {
		this.#base.info( ...messages );
	};

	warn = ( ...messages ) => {
		this.#base.warn( ...messages );
	};

	error = ( ...messages ) => {
		this.#base.error( ...messages );
	};

	group = ( ...messages ) => {
		this.#base.group( ...messages );
	};

	groupCollapsed = ( ...messages ) => {
		this.#base.groupCollapsed( ...messages );
	};

	groupEnd = ( ...messages ) => {
		this.#base.groupEnd();
	};

	table = ( ...messages ) => {
		this.#base.table( ...messages );
	};

}